import React from 'react'
import { useMenuChiSiamoQuery } from 'gql/graphql'
import { WContainer } from 'components/atoms'
import {
  Page,
  ChiSiamoMenu,
  ChiSiamoSlider,
  CantineHomeBox,
  ChiSiamoReferenze,
} from 'components/organisms'
import Head from 'next/head'
import { DOMAIN } from 'utils/settings'
import { useRouter } from 'next/router'

interface Props {
  pagina?: string
}

const ChiSiamoTemplate = (props: Props) => {
  const { data: chiSiamoItems } = useMenuChiSiamoQuery()
  const router = useRouter()

  const { pagina = '' } = props

  function getItems(chiave) {
    const item1 = chiSiamoItems?.menuitem?.children?.edges.find((item) => item.node.key === chiave)

    return item1
      ? item1.node.children.edges.map((item2) => ({
          pk: item2.node.pk,
          image: item2.node.image,
          name: item2.node.name,
          description: item2.node.description,
          key: item2.node.key,
        }))
      : []
  }

  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'AboutPage',
    'name': 'Vinicum',
    'description':
      "Vinicum è un sito web dedicato al mondo del vino, che offre una vasta selezione di vini provenienti da cantine di prestigio in tutta Italia. Fondata con l'obiettivo di portare l'eccellenza enologica direttamente sulla tavola dei consumatori, Vinicum si distingue per la sua curata selezione di etichette, che spaziano dalle classiche denominazioni italiane ai vini di nicchia e alle novità del settore.",
    'url': `${
      router.locale === 'en'
        ? `${DOMAIN}/${router.locale}${pagina['url']}`
        : `${DOMAIN}${pagina['url']}`
    }`,
    'publisher': {
      '@type': 'Organization',
      'name': 'Vinicum',
      'url': `${
        router.locale === 'en'
          ? `${DOMAIN}/${router.locale}${pagina['url']}`
          : `${DOMAIN}${pagina['url']}`
      }`,
      'logo': {
        '@type': 'ImageObject',
        'url': `${`${DOMAIN}/images/logo-vinicum-bianco.png`}`,
        'width': 80,
        'height': 61,
      },
      'contactPoint': {
        '@type': 'ContactPoint',
        'telephone': '+39 045 6269600',
        'contactType': 'customer service',
        'areaServed': 'IT',
        'availableLanguage': ['Italian', 'English'],
      },
    },
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>

      <Page
        pagina={pagina}
        topBg="center"
        childrenContainerVariant="none"
        className="chi-siamo-template"
      >
        <WContainer>
          <ChiSiamoMenu items={getItems('benvenuto')} />
        </WContainer>
        <ChiSiamoSlider items={getItems('slider')} />
        <WContainer>
          <CantineHomeBox />
        </WContainer>
        <ChiSiamoReferenze items={getItems('referenze')} />
      </Page>
    </>
  )
}

export default ChiSiamoTemplate
